export default [
	{
		path: '/LCActivity',
		name: 'LCActivity',
		component: () => import(/* LCActivity*/ './index.vue'),
		meta: {
			title: '',
			// keepAlive: true  //是否设置为缓存数据页面
		},
		children: [
			{
				path: 'mp/index',
				name: 'LCActivity_index',
				component: () => import(/* LCActivity_index */ './pages/mp/pay/index.vue'),
				meta: {
					title: '',
					// keepAlive: true  //是否设置为缓存数据页面
				},
			},
			{
				path: 'mpFree/index',
				name: 'LCActivity_free_index',
				component: () => import(/* LCActivity_free_index */ './pages/mp/free/index.vue'),
				meta: {
					title: '',
					// keepAlive: true  //是否设置为缓存数据页面
				},
			}
		]
	}
]
